import React, { useEffect, useState } from 'react';
import { AcquisitionFlow, getAcquisitionFlow, getAppData } from '../../../utils/acquisition-utils';
import { useAcquisitionContext } from '../../../providers/AcquisitionProvider/AcquisitionProvider';
import { transformHTMLParserLinks } from '../../../utils/rewriteLink/rewriteLink';

interface ICreditProtectionProps {
    enrolledLabel?: string;
    creditProtectionStatement?: string;
}


const getCreditProtectionSelection = async (): Promise<boolean> => {
    const appData = await getAppData();
    const flow = getAcquisitionFlow();
    if (flow === AcquisitionFlow.PA && appData.CreditProtection) {
        return appData.CreditProtection.IsCreditProtectionSelected;
    } else if (flow === AcquisitionFlow.PHA) {
        return appData?.creditProtectionSelected ?? false;
    }
    return appData.CreditProtectionSelected;
    
};

export const CreditProtectionForm = (props: ICreditProtectionProps) => {
    const [isCreditProtectionSelected, setIsCreditProtectionsSelected] = useState<boolean>();

    const { hasFocusedCreditProtection } = useAcquisitionContext();

    useEffect(() => {
        getCreditProtectionSelection().then(val => {
            setIsCreditProtectionsSelected(val);
        });
    }, [hasFocusedCreditProtection]);

    return (
        <>
            <div className='PersonalInformation__infoContainer'>
                <p>
                    <b>{props.enrolledLabel}:</b>
                </p>
                <p>
                    {isCreditProtectionSelected ? <React.Fragment>Yes <b>($0.96 per $100)</b></React.Fragment> : 'No'}
                </p>
            </div>
            {!isCreditProtectionSelected && 
                <div className='PersonalInformation__creditProtectionStatement'>
                    {transformHTMLParserLinks(props.creditProtectionStatement)}
                </div>
            }
        </>
    );
};